import { Component, OnInit, input, output } from '@angular/core';
import { HeadingComponent } from "../../../../shared/components/heading/heading.component";
import { ButtonModule } from 'primeng/button';
import {DocumentService} from '../../../../shared/services/document-service';
import { Documents, UploadEvent, Document } from '../profile.interface';
import { FileUploadModule } from 'primeng/fileupload';
import { constants } from '../../../../shared/constants/constants';
import {ToastService} from '../../../../shared/services/toast.service';
import { CookieService } from 'ngx-cookie-service';
import { TooltipModule } from 'primeng/tooltip';
import { Router } from '@angular/router';
import { HelperService } from '../../../../shared/services/helper.service';
import { PipesModule } from '../../../../shared/pipes/pipes.module';
import { CommonBaseClass } from '../../../../shared/classes/common-base-class';
import { ConfigurationService } from '../../../../shared/services/configuration.service';

@Component({
    selector: 'app-resume',
    standalone: true,
    templateUrl: './resume.component.html',
    styleUrl: './resume.component.scss',
    imports: [HeadingComponent, ButtonModule, FileUploadModule, TooltipModule, PipesModule]
})
export class ResumeComponent extends CommonBaseClass implements OnInit {
    from = input<string>('');
    nextStep = output<void>();
    backStep = output<void>();

    document:Documents = [];
    resume!:any;
    certifications: Documents = [];
    additionalDocuments: Documents = [];
    breadcrumbTitleOptions = [
        { label: 'Profile' }, 
        { label: 'Resume' }
    ];
    isPwcEnabled = false;

    constructor(private cookieService: CookieService, private documentService: DocumentService, private toast: ToastService, private router: Router, private configurationService: ConfigurationService,helperService: HelperService) { 
        super(helperService);
        this.isPwcEnabled = this.configurationService.getPwcFlag();
    }

    isMobileFromCookie = this.cookieService.get('isMobile');

    ngOnInit(): void {
        this.getDocuments();
        
    }
    getDocuments(){
        this.additionalDocuments = [];
        this.certifications = [];
        this.resume = null;
        this.documentService.getDocuments().subscribe((resp:Documents)=>{
            this.filterDocumentData(resp)
        })
    }

    downloadDocument(data:Document){
        if(data.url)
            window.open(data.url, '_self');
    }
    filterDocumentData(data:Documents){
        if(data.length > 0){
            data.map((d:Document)=>{
                switch (d.documentType) {
                    case constants.documentTypes.resume:
                        this.resume = d;
                        this.resume.url= this.documentService.getDocumentPathById(this.resume._id);
    
                        break;
    
                    case constants.documentTypes.certification:
                        const certification = d;
                        certification.url = this.documentService.getDocumentPathById(d._id);
                        this.certifications.push(certification);
                        break;
    
                    case constants.documentTypes.additionalDocument:
                        const data = d;
                        data.url =  this.documentService.getDocumentPathById(d._id) 
                        this.additionalDocuments.push(data);
                        break;
                }
            })
           
        }
    }

    onUploadDocument(event: any, type:string): void {
        console.log(event.target.files[0]);
        const file = event.target.files[0];
        if(this.isPwcEnabled && file.type !== 'application/pdf'){
            this.toast.showError('Only PDF files are allowed');
            return;
        }
        let opts = { documentType: type};
        this.uploadDocument(file,opts);
    }
    editDocument(event: any, type:string, data:Document){
        const file = event.target.files[0];
        if(this.isPwcEnabled && file.type !== 'application/pdf'){
            this.toast.showError('Only PDF files are allowed');
            return;
        }
        const addDocument = { type: type, file: file};
        this.deleteDocment(data._id,true,addDocument)
    }
    deleteDocment(id:string,edit?:boolean, data?:any){
        this.documentService.deleteDocument(id).subscribe((d:any)=>{
            if(edit){
                let opts = { documentType: data.type};
                this.uploadDocument(data.file,opts);
            }else{
                this.toast.showSuccess('Document deleted successfully');
                this.getDocuments();
            }
        })
    }

    uploadDocument(file:any,opts:any){
        this.documentService.uploadDocument(file,opts).subscribe((d:any)=>{
            this.toast.showSuccess('Document uploaded successfully');
            this.getDocuments();
        })
    }

    onNext(): void {
        this.nextStep.emit();
    }

    onBack(): void {
        if (this.from() === 'onboarding') {
            this.backStep.emit();
        } else {
            this.navigateToMainProfile();
        }
    }
}
